import { AlertContext, Builder_, Confirmation_, Dates_, Grey_Link, Main_, Partial_Loader, Slider_, device } from 'monica-alexandria';
import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import l from "../../../services/api/Landings";
import { alertMessage } from '../../../utils/messagesAlerts';

const CrmRestoreLeads = styled.div`
  .SliderWrapper {
    max-width: 30%;

    @media ${device.md} {
      max-width: 100%;
    }
  }
`;

export default function Crm_Restore_Leads(props) {
  const { t } = useTranslation();
  const { alerts, setAlerts } = useContext(AlertContext);

  const [range, setRange] = useState({ startDate: '', endDate: '', renderedDates: '' });
  const [searching, setSearching] = useState(false);
  const [restoring, setRestoring] = useState(false);
  const [foundCount, setFoundCount] = useState(null);
  const [confirmRestore, setConfirmRestore] = useState(false);

  const onChange = (selections) => {
    setRange({
      startDate: selections?.[0] || '',
      endDate: selections?.[1] || '',
      renderedDates: selections,
    });
  };

  const getPayloadDates = () => {
    if (!range.startDate || !range.endDate) return {};
    const start = new Date(range.startDate);
    const end = new Date(range.endDate);
    return {
      startDate: start.toISOString(),
      endDate: end.toISOString(),
    };
  };

  const onSearch = async () => {
    if (!range.startDate || !range.endDate) {
      alertMessage(alerts, setAlerts, t("Please select a start and end date"), "Error");
      return;
    }

    setSearching(true);
    const { startDate, endDate } = getPayloadDates();
    const res = await l.findMissingLeads(props.questId, startDate, endDate);
    const count = res?.data?.count ?? 0;
    setFoundCount(count);
    setSearching(false);

    if (count > 0) {
      setConfirmRestore(true);
    } else {
      alertMessage(alerts, setAlerts, t("No missing leads found"), "Info");
    }
  };

  const onRestore = async () => {
    setRestoring(true);
    const { startDate, endDate } = getPayloadDates();
    const res = await l.restoreMissingLeads(props.questId, startDate, endDate);
    const restored = res?.data?.restored ?? 0;
    setRestoring(false);
    setConfirmRestore(false);

    alertMessage(
      alerts,
      setAlerts,
      `${t("Restored")} ${foundCount} ${t("missing leads")}`,
      "Success"
    );

    props.onRestored?.();
    props.onClose?.();
  };

  return (
    <CrmRestoreLeads>
      {confirmRestore && (
        <Confirmation_
          message={`${t("Found")} ${foundCount} ${t("missing leads")}! ${t("Restore")}?`}
          no={t("No")}
          onNo={() => setConfirmRestore(false)}
          onYes={onRestore}
          yes={t("Yes")}
        />
      )}

      <Slider_
        title={t("Restore")}
        iconGreyLeft='Xicon'
        iconMainRight='Xicon'
        grey={t("Cancel")}
        onGrey={props.onClose}
        onClose={props.onClose}
      >
        <Builder_ title={`${t("Select the date range to search for missing leads")}.`}>
          <Dates_
            allowPartialRange={true}
            onChange={onChange}
            value={range?.renderedDates}
            selectRange={true}
            dateFullCellRender={(date) => date?.date()}
            maxDate={new Date()}
          />
          <Grey_Link
            text={t("Clear dates")}
            iconLeft='Xicon'
            onClick={() => setRange({ startDate: '', endDate: '', renderedDates: '' })}
          />
        </Builder_>

        {searching || restoring ? (
          <Partial_Loader />
        ) : (
          <Main_
            text={t("Search for missing leads")}
            iconRight="Search"
            onClick={onSearch}
          />
        )}
      </Slider_>
    </CrmRestoreLeads>
  );
}
